import {
  Box,
  Button,
  Collapsible,
  constants,
  PlusIcon,
  Text,
} from '@redbubble/design-system';
import { useIntl } from '@redbubble/next/intl';
import React from 'react';
import styles from './Coupon.module.scss';
import { couponMessages } from './messages';

const CouponOrGiftCardTrigger = ({
  setDrawerOrAccordionClosed,
  collapsed,
  toggleCollapsible,
  availableCoupons,
}) => {
  // biome-ignore lint/correctness/useHookAtTopLevel: useHookAtTopLevel
  // biome-ignore lint/correctness/useHookAtTopLevel: useHookAtTopLevel
  const intl = useIntl();

  const toggleCouponPanel = () => {
    toggleCollapsible();
    setDrawerOrAccordionClosed(!collapsed);
  };

  if (!collapsed) {
    return (
      <Box display="flex" marginBottom="s">
        <Text type="display5">
          {intl.formatMessage(couponMessages.couponGiftCard)}
        </Text>
        <button
          type="button"
          className={styles.changeOrCloseButton}
          onClick={toggleCouponPanel}
        >
          {intl.formatMessage(couponMessages.close)}
        </button>
      </Box>
    );
  }

  return (
    <Box
      display="flex"
      flexDirection="column"
      justifyContent="center"
      alignItems="center"
      className={[styles.couponTrigger, styles.accordionTrigger].join(' ')}
    >
      <Button
        intent={constants.NEUTRAL}
        size={constants.SMALL}
        iconBefore={<PlusIcon size={constants.SMALL} aria-hidden />}
        aria-expanded={false}
        onClick={toggleCouponPanel}
      >
        {intl.formatMessage(couponMessages.addCouponGiftCard)}
      </Button>
      {availableCoupons > 0 && (
        <Text
          type="caption"
          className={styles.availableCoupons}
          textAlign={constants.CENTER}
        >
          {intl.formatMessage(couponMessages.couponAvailable, {
            count: availableCoupons,
          })}
        </Text>
      )}
    </Box>
  );
};

type AccordionTriggerProps = {
  children: JSX.Element | JSX.Element[];
  setDrawerOrAccordionClosed: (boolean) => void;
  drawerOrAccordionClosed: boolean;
  availableCoupons: number;
};

export const AccordionTrigger = ({
  children,
  setDrawerOrAccordionClosed,
  drawerOrAccordionClosed,
  availableCoupons,
}: AccordionTriggerProps) => (
  <Collapsible
    display="flex"
    trigger={(triggerProps) =>
      CouponOrGiftCardTrigger({
        setDrawerOrAccordionClosed,
        availableCoupons,
        ...triggerProps,
      })
    }
    defaultCollapsed={drawerOrAccordionClosed}
  >
    {children}
  </Collapsible>
);
